import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import UploadAttachments from '../../commonComponents/shared/UploadAttachments';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class ApplicationAttachmentsUploadModal extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            deletedAttachments: [],
            newAttachments: [],
            error: false
        };

        this.state = this.initialState;
    }

    updateAttachments = newAttachments => {
        this.setState({ newAttachments });
    }

    deleteAttachment = (attachment) => {
        if (this.props.attachments.indexOf(attachment) >= 0) {
            this.setState({
                deletedAttachments: [...this.state.deletedAttachments, attachment.documentId]
            });
        }
    }

    onClose = () => {
        this.setState(this.initialState);
        this.props.close();
    }

    onSubmit = async () => {
        await this.props.updateAttachments(this.props.applicationId, {
            newAttachments: this.state.newAttachments,
            deletedAttachments: this.state.deletedAttachments
        });

        if (this.props.success) {
            this.onClose();
        } else {
            this.setState({ error: true });
        }
    }

    render() {
        const { attachments, loading, message } = this.props;
        const { deletedAttachments, newAttachments, error } = this.state;

        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="bordered-modal-header">
                            <h4 className="page-header">Manage Attachments</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose} />
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <label className="input-label"><i className="icon ion-paperclip icon-left xl-text middle" />
                                        Attachment(s):</label>
                                    {attachments &&
                                        <ul>{attachments.map((attachment, index) => {
                                            if ((deletedAttachments.indexOf(attachment.documentId)) < 0) {
                                                return (<li key={attachment.name}>
                                                    <i className="icon ion-document icon-left middle" />
                                                    <label className="small-text">{attachment.name}</label>
                                                    <i className="icon ion-ios-close-outline trash-hover icon-right middle"
                                                        onClick={() => this.deleteAttachment(attachment)} /></li>)
                                            }
                                            return null;
                                        })
                                        }</ul>
                                    }
                                </div>
                            </div>
                            <div className="modal-row">
                                <UploadAttachments files={newAttachments} name="newAttachments"
                                    onChange={(name, val) => this.updateAttachments(val)} />
                            </div>
                        </div>
                        {loading ? <LoadingSpinner height="20" alignRight={true} />
                            : <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onSubmit}
                                    disabled={!newAttachments.length && !deletedAttachments.length}>Submit</button>
                                <FadeOutErrorMessage show={error} message={message} />
                            </div>}
                    </div>
                </div>
            </Modal >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/ApplicationAttachmentsUploadModal.jsx